import * as z from "zod";
import { null as zNull } from "zod";
import { marketWithCountriesOutput } from "./market";

/** All cross-border markets configured for the authenticated team, each with
 * its per-country publish targets. */
export const getMarkets = {
  name: "getMarkets" as const,
  input: zNull(),
  output: z.object({ markets: z.array(marketWithCountriesOutput) }),
};
